import React from 'react';
import styles from './MarketName.module.scss';

const MarketName = ({ name }) => {
    return <span className={styles.marketName}>{name}</span>;
};

export default MarketName;
